import { ArrowDown, ArrowTop } from "@/icons";
import { ToggleLabel } from "../types";
import clsx from "clsx";

type Props = {
  className?: string;
  isOpen: boolean;
  onClick: () => void;
  toggleLabels: ToggleLabel;
};

const ToggleContent = ({ isOpen, onClick, className, toggleLabels }: Props) => {
  return (
    <button className={clsx("", className)} onClick={onClick}>
      {isOpen ? toggleLabels.closeLabel : toggleLabels.activeLabel}
      <span className="arrow">{isOpen ? <ArrowTop /> : <ArrowDown />}</span>
    </button>
  );
};

export default ToggleContent;
